import { CloudActions } from 'reactApp/constants/cloudActions';

import { APICallV2Post } from './APICall';

export class TrashbinEmptyApiCall extends APICallV2Post {
    _method = 'trashbin/empty';
    _headers = { 'X-VFS-Action': CloudActions.TRASHBIN_EMPTY };
}
